export function receiptSettings(value = {}) {
  const width = value.width || "80mm";
  const mode = value.mode || "COMPACT";
  const fontScale = Number(value.fontScale ?? 1);
  if (!["58mm", "80mm"].includes(width) || !["COMPACT", "DETAILED"].includes(mode)
    || !Number.isFinite(fontScale) || fontScale < 0.8 || fontScale > 1.5) {
    throw new Error("Choose a valid receipt width, detail level and font scale between 0.8 and 1.5.");
  }
  return { width, mode, fontScale };
}

export function receiptPrintStyles(value) {
  const { width, mode, fontScale } = receiptSettings(value);
  return `@media print {
    @page { size: ${width} auto; margin: 0; }
    body { width: ${width}; margin: 0; }
    .wrap { width: auto; max-width: none; margin: 0; padding: 3mm; border: none; border-radius: 0; }
    .header { gap: 2mm; flex-wrap: wrap; }
    .logo { max-width: 20mm; height: auto; max-height: 20mm; }
    h1 { font-size: ${14 * fontScale}px; }
    body, th, td, tfoot td { font-size: ${11 * fontScale}px; }
    .muted, .footer, .badge { font-size: ${9 * fontScale}px; }
    th, td { padding: 2mm 1mm; overflow-wrap: anywhere; }
    .print-note { display: none; }
    ${mode === "COMPACT" ? "tbody .muted { display: none; }" : ""}
  }`;
}
